import { useFeatureFlags, useLoggedInUser } from '@tcc/shared-data-lib';
import React from 'react';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';
import { Operation } from '../../hooks/useOperations/types';
import { importFromS3 } from '../../utils/importFromS3';
import {
  useFeatureFlagsConfigs,
  useUserLoggedInConfigs,
} from '../../utils/sharedData';

interface InSeasonPluginContainerProps {
  operations: Operation[];
  operationsSelected: string[];
}

const S3Plugin = React.lazy(() => importFromS3('tcc-in-season-web'));
const MFPlugin = React.lazy(() => import('inSeasonWeb/InSeasonWeb'));

export const InSeasonPluginContainer: React.FC<
  InSeasonPluginContainerProps
> = ({ operations, operationsSelected }) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.inSeason.module-federation'];

  const InSeasonPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  const { operation: impersonatedOperation } = useImpersonatedOperation();

  const operationIds = impersonatedOperation
    ? [impersonatedOperation.operationId]
    : operationsSelected;

  return (
    <InSeasonPlugin operations={operations} operationsSelected={operationIds} />
  );
};
